var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.3333V13.4448C14.9997 13.8572 14.8357 14.2526 14.5442 14.5442C14.2526 14.8357 13.8572 14.9997 13.4448 15H2.55517C2.14281 14.9997 1.74742 14.8357 1.45584 14.5442C1.16426 14.2526 1.00031 13.8572 1 13.4448V10.3333M4.1115 6.44483L8 10.3333M8 10.3333L11.8885 6.44483M8 10.3333V1",
    stroke: "#616874",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.e1e49efc60339c9748055462bb256966.svg";
export { ForwardRef as ReactComponent };